/**
 * WordPress dependencies
 */
import { useContext } from '@wordpress/element';
import { useObservableValue } from '@wordpress/compose';

/**
 * Internal dependencies
 */
import SlotFillContext from './slot-fill-context';
export default function useSlot(name) {
  const registry = useContext(SlotFillContext);
  const slot = useObservableValue(registry.slots, name);
  return {
    ...slot
  };
}